<ng-container>
  @if (otpError) {
    <p class="text-warn">
      {{ otpError }}
    </p>
  }
  <form [formGroup]="otpForm" (submit)="emitOtp()">
    <p>
      We sent an OTP to your device, Please enter the OTP below to confirm
      transaction
    </p>
    <div class="flex-container otp-header_margin">
      <input
        class="form-control"
        id="OTP"
        #otp
        formControlName="otp"
        type="text"
        required
        placeholder=" "
        />
      <label for="OTP">Enter OTP</label>
    </div>
    <p>
      Didn't get code?
      <span
        class="text_primary ml-2"
        (click)="resendOtp()"
        style="cursor: pointer"
        >Resend Code</span
        >
      </p>

      <div class="flex-container">
        <button
          [disabled]="!otpForm.valid"
          class="btn w-100 form-btn text-white no-margin-l no-margin-r"
        [style.background-color]="
          whiteLabelInfo?.brandColor ? whiteLabelInfo?.brandColor : '#ed1c25'
        "
          type="submit"
          >
          <span>Confirm Payment</span>
        </button>
        <!-- <div *ngIf="isLoading" class="form_button">
        <img src="" alt="" class="class fa fa-spinner fa-spin" />
        Loading...
      </div> -->
    </div>
  </form>
</ng-container>
